<!--
    Styles
-->

<style>


    /* main */

    .l-nav {
        height: 60px;
        position: relative;
        border-bottom: 1px solid var(--cl-gray);
        z-index: 1;
    }


    /* search */

    .l-nav .search {
        margin: 0 12px;
    }


    /* ui */

    .l-nav .ui-dropdown {
        max-width: 150px;
        min-width: 100px;
    }
    .l-nav .ui-select {
        height: 60px;
        padding: 0 10px;
        border-left: 1px solid var(--cl-gray);
    }
    .l-nav .ui-select:hover {
        background: var(--cl-blue-light);
    }
    .l-nav .ui-range {
        width: 260px;
        right: -1px;
        border-top: 0;
    }


    /* submit */

    .l-nav .submit {
        height: 100%;
        position: relative;
    }


    /* submit button */

    .l-nav .submit > .button {
        width: 150px;
        height: 100%;
        text-align: center;
        background: var(--cl-orange);
        color: var(--cl-white);
        transition: background 0.3s ease;
    }
    .l-nav .submit > .button p {
        margin: 1px 0;
    }
    .l-nav .submit > .button .count {
        position: absolute;
        top: 4px;
        right: 4px;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 50%;
        background: var(--cl-red);
    }
    .l-nav .submit > .button.blink {
        animation: blink 0.5s ease;
    }
    @keyframes blink {
        0%   {background: var(--cl-orange)}
        50%  {background: var(--cl-orange-dark)}
        100% {background: var(--cl-orange)}
    }


    /* submit dropdown */

    .l-nav .submit .dropdown {
        display: none;
        position: absolute;
        right: 0;
        top: 100%;
        width: 380px;
    }
    .l-nav .submit .dropdown .building {
        padding: 10px;
    }
    .l-nav .submit:hover .dropdown {
        display: block;
    }

    .l-nav .bldgtypes .dropdown,
    .l-nav .types .dropdown {
        border-top: 0;
    }

    .l-nav .types .ui-select .value {
        font-size: 13px;
        font-weight: 500;
    }

    .l-nav .bldgtypes .dropdown .option {
        font-weight: 500;
    }
    .l-nav .bldgtypes .dropdown .cancel {
        border-top: 1px solid var(--cl-gray);
    }
    .l-nav .bldgtypes .dropdown .cancel.disabled {
        pointer-events: none;
        color: var(--cl-gray);
    }




</style>



<!--
    Template
-->

<template>
    <nav class="l-nav u-row">


        <!-- search -->

        <nav-search v-if="$route.name === 'dashboard'" class="search u-flex" />
        <nav-search-text v-else class="search u-flex" />


        <!-- type -->

        <!--
        <ui-dropdown
            class="types u-flex"
            v-slot="{active, toggle}"
        >
            <ui-select
                :value="types[params.type]"
                @click.native="toggle"
            />
            <ui-options
                v-show="active"
                :options="types"
                @update="setQuery({type: types[$event]})"
            />
        </ui-dropdown>
        -->


        <!-- building type -->

        <ui-dropdown class="bldgtypes u-flex" v-slot="{active, toggle}">
            <ui-select
                label="物件種別"
                :value="buildingTypes[params.buildingType]"
                @click.native="toggle"
            />
            <ui-options
                v-show="active"
                :options="buildingTypes"
                @update="setQuery({buildingType: buildingTypes[$event].value})"
            >
                <a class="cancel cl-blue option" :class="{disabled: !params.buildingType}" @click="setQuery({buildingType: undefined}); toggle()">クリア</a>
            </ui-options>
        </ui-dropdown>


        <!-- filters -->

        <ui-dropdown
            class="u-flex"
            v-for="{label, key, unit, range, keys} of filters"
            v-slot="{active, toggle}"
            :key="key"
        >
            <ui-select
                :label="label"
                :value="{min: params[keys.min], max: params[keys.max], label: unit} | value"
                @click.native="toggle"
            />
            <ui-range
                v-show="active"
                :label="unit"
                :min="params[keys.min]"
                :max="params[keys.max]"
                :options="range"
                @update="setQuery({[keys.min]: $event.min, [keys.max]: $event.max})"
            />
        </ui-dropdown>


        <!-- submit -->

        <div class="submit">

            <router-link class="button u-col" ref="button" :to="{name: 'compare', query: selectedQuery}" :event="deals ? 'click' : ''">
                <p class="w7">比較レポート</p>
                <p class="t10">最大5件まで選択可能</p>
                <div class="count w7" v-show="deals">{{ deals }}</div>
            </router-link>

            <div class="dropdown" v-show="deals">
                <item-building class="t11 building" v-for="building in selected" :key="building.id" :building="building" />
            </div>

        </div>


    </nav>
</template>



<!--
    Scripts
-->

<script>


    // imports

    import {mapState, mapGetters} from 'vuex'
    import * as enums from '@/common/helpers/enums'
    import buildingTypes from '@/common/configs/types'
    import ranges from '@/common/configs/filters'
    import uiDropdown from '@/components/shared/ui/dropdown.vue'
    import uiRange from '@/components/shared/ui/range.vue'
    import uiSelect from '@/components/shared/ui/select.vue'
    import uiOptions from '@/components/shared/ui/options.vue'
    import itemBuilding from '@/components/dashboard/items/building.vue'
    import navSearch from './nav.search.vue'
    import navSearchText from './nav.search.text.vue'


    // helpers

    const exists = param => {
        return param !== null && param !== undefined;
    };

    const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);


    // constants

    const types = enums.fromValues({
        '売買': 'sale',
        '賃貸': 'rent'
    });

    const units = {
        sqm: 'm²',
        price: '万円',
        builtAt: '年',
        dealtAt: '年'
    };

    const filters = {
        condo: {
            '専有面積': 'sqm',
            '金額': 'price',
            '築年': 'builtAt',
            '募集･成約年': 'dealtAt'
        },
        house: {
            '延床面積': 'sqm',
            '土地面積': 'landSqm',
            '金額': 'price',
            '築年': 'builtAt',
            '募集･成約年': 'dealtAt'
        },
        land: {
            '土地面積': 'landSqm',
            '金額': 'price',
            '募集･成約年': 'dealtAt'
        }
    };

    const defaults = {
        filters: {
            '広さ': 'sqm',
            '金額': 'price',
            '築年': 'builtAt',
            '募集･成約年': 'dealtAt'
        }
    };


    // exports

    export default {

        components: {
            uiSelect,
            uiDropdown,
            uiRange,
            uiOptions,
            navSearch,
            navSearchText,
            itemBuilding
        },

        filters: {

            value ({min, max, label}) {
                if (!exists(min) && !exists(max)) return '';
                min = exists(min) ? min : '';
                max = exists(max) ? max : '';
                return `${min} ~ ${max} ${label}`;
            }

        },

        data () {
            return {
                types,
                buildingTypes
            }
        },

        computed: {

            ...mapState('search', [
                'params',
                'selected'
            ]),

            ...mapGetters('search', [
                'selectedDeals',
                'selectedQuery'
            ]),

            ...mapState('dashboard', [
                'hovered'
            ]),

            deals () {
                return this.selectedDeals.length
            },

            filters () {
                const fls = filters[this.params.buildingType] || defaults.filters;
                return Object
                    .entries(fls)
                    .map(([label, key]) => ({
                        label,
                        key,
                        range: ranges[key],
                        unit: units[key],
                        keys: {
                            min: 'min' + capitalize(key),
                            max: 'max' + capitalize(key)
                        }
                    }));
            }


        },

        watch: {

            'hovered.deal' (value) {
                if (!value) return;
                this.$refs.button.$el.classList.remove('blink');
                this.$refs.button.$el.offsetHeight; // reflow
                this.$refs.button.$el.classList.add('blink');
            }

        },

        methods: {

            setQuery (query) {
                this.$router.push({
                    name: this.$route.name,
                    query: {...this.$route.query, ...query}
                });
            }

        }


    }

</script>
